export enum LoadingStatus {
    idle = "idle",
    loading = "loading",
    succeeded = "succeeded",
    failed = "failed",
}